module.exports = __webpack_public_path__ + "media/svg/education-d13e9604.svg";